export default __webpack_public_path__ + "static/media/icon-link-copy-3.6564b6f2.svg";